import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '100vh',
        backgroundColor: theme.palette.secondary.dark80,
        paddingTop: 30,
        position: 'relative',
        zIndex: 5,
        paddingBottom: 25,
        borderRadius: '0 0 30px 30px',
        overflow: 'hidden',
    },
    Heading: {
        marginTop: 10,
        color: theme.palette.secondary.light,
        fontFamily: "'Quicksand', sans-serif",
        fontWeight: 400,
        fontSize: '1.5rem',
        [theme.breakpoints.up('sm')]: {
            fontSize: '1.7rem',
        }
    },
    section: {
        margin: '50px 0'
    },
    cardNoticia: {
        minHeight: '100vh',
        backgroundColor: "#fff",
        borderRadius: '20px 20px 40px 10px'
    }
}));